
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nomoredebttoday/privacy-policy",
      function () {
        return require("private-next-pages/nomoredebttoday/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nomoredebttoday/privacy-policy"])
      });
    }
  